export default "__VITE_ASSET__CQBBHz4f__"